import { sf_dotdangky_dichvu } from "../../models/response/category/sf_dotdangky_dichvu"
import {
    DotDangKyDichVuActionTypeIds,
    DotDangKyDichVuLoadStartAction, DotDangKyDichVuLoadSuccessAction, DotDangKyDichVuLoadErrorAction, DotDangKyDichVuShowDetailModalAction,
    DotDangKyDichVuSaveStartAction, DotDangKyDichVuSaveSuccessAction, DotDangKyDichVuSaveErrorAction, DotDangKyDichVuDeleteStartAction, DotDangKyDichVuDeleteSuccessAction, DotDangKyDichVuDeleteErrorAction, DotDangKyDichVuChangeSelectedIdsAction, DotDangKyDichVuShowDeleteConfirmAction, DotDangKyDichVuCloseDetailModalAction
} from "../action-types/dotDangKyDichVuActionTypes"

export const loadDotDangKyDichVuStart = (): DotDangKyDichVuLoadStartAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_START
    }
}

export const loadDotDangKyDichVuSuccess = (payload: sf_dotdangky_dichvu[]): DotDangKyDichVuLoadSuccessAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_SUCCESS,
        payload: payload
    }
}
export const loadDotDangKyDichVuError = (payload: string): DotDangKyDichVuLoadErrorAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_ERROR,
        payload: payload
    }
}

export const showDotDangKyDichVuDetailModal = (payload?: sf_dotdangky_dichvu): DotDangKyDichVuShowDetailModalAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SHOW_DETAIL_MODAL,
        payload: payload
    }
}

export const closeDotDangKyDichVuDetailModal = (): DotDangKyDichVuCloseDetailModalAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_CLOSE_DETAIL_MODAL,
    }
}

export const showDotDangKyDichVuDeleteConfirm = (payload: boolean): DotDangKyDichVuShowDeleteConfirmAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SHOW_DELETE_CONFIRM,
        payload: payload
    }
}

export const saveDotDangKyDichVuStart = (payload: sf_dotdangky_dichvu): DotDangKyDichVuSaveStartAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_START,
        payload: payload
    }
}

export const saveDotDangKyDichVuSuccess = (payload: sf_dotdangky_dichvu): DotDangKyDichVuSaveSuccessAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_SUCCESS,
        payload: payload
    }
}
export const saveDotDangKyDichVuError = (payload: string): DotDangKyDichVuSaveErrorAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_ERROR,
        payload: payload
    }
}

export const deleteDotDangKyDichVuStart = (payload: number): DotDangKyDichVuDeleteStartAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_START,
        payload: payload
    }
}

export const deleteDotDangKyDichVuSuccess = (payload: number): DotDangKyDichVuDeleteSuccessAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_SUCCESSS,
        payload: payload
    }
}
export const deleteDotDangKyDichVuError = (payload: string): DotDangKyDichVuDeleteErrorAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_ERROR,
        payload: payload
    }
}

export const changeDotDangKyDichVuSelectionIds = (payload: number): DotDangKyDichVuChangeSelectedIdsAction => {
    return {
        type: DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_CHANGE_SELECTED_ID,
        payload: payload
    }
}